import React from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PermissionTable from "../../components/PermissionsManager/PermissionTable";

const PermissionsManager = () => {
  return (
    <div className="page-content">
      <Breadcrumbs title="Settings" breadcrumbItem="Permission Manager" />
      <PermissionTable />
    </div>
  );
};

export default PermissionsManager;